const cdnBasePath = `https://${process.env.REACT_APP_CDNBASEPATH}`;
const PROMOTIONS = {
  APPLY_PROMO_TITLE: "apply / select promo code",
  INPUT_PLACEHOLDER: "Enter Promo",
  PROMO_APPLY_BTN: "apply promo",
  APPLY_PROMO_IMAGE:
    `${cdnBasePath}/client/assets/images/promotions/icon_promo.png`,
};

export default PROMOTIONS;



// WEBPACK FOOTER //
// ./src/constants/promotions.js